import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  RequestableApproverOption,
  type RequestableApproverOptionConstructor,
} from './RequestableApproverOption'

export const RequestableApproverOptionConstructorFactory =
  Factory.Sync.makeFactory<RequestableApproverOptionConstructor>({
    id: Factory.each(() => faker.random.number()),
    userId: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    levelText: null,
    groupName: null,
    approvalDelegatee: null,
  })

export const RequestableApproverOptionFactory = EntityFactory(
  RequestableApproverOption,
  RequestableApproverOptionConstructorFactory
)
